import React from "react";
const ProductsDropDown = ({ active }) => {
  return (
    <div
      className={`z-[999] box-border md:absolute md:left-[-100%] md:top-[200%] md:w-[480px] w-screen fixed left-[0] bottom-[68px] ${
        active
          ? "opacity-100 visible translate-y-0 duration-300"
          : "opacity-0 invisible translate-y-[-10px] duration-300"
      }`}
    >
      <div className="rounded-lg p-20px w-full flex flex-col gap-10px bg-white dark:bg-accent-900 shadow-md dark:border-accent-600 dark:border">
        <h5 className="m-0 text-primary-500 text-xs font-semibold">Products</h5>
        <div className="w-full box-border rounded-md cursor-pointer duration-300 hover:bg-primary-50 dark:hover:bg-accent-800">
          <div className="flex gap-16px p-12px m-0 w-full">
            <div className="img">
              <svg
                width="30"
                height="30"
                viewBox="0 0 30 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  width="30"
                  height="30"
                  rx="15"
                  className="dark:fill-accent-700"
                />
                <mask
                  id="mask0_48_2197"
                  maskUnits="userSpaceOnUse"
                  x="5"
                  y="5"
                  width="20"
                  height="20"
                >
                  <rect x="5" y="5" width="20" height="20" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_48_2197)">
                  <path
                    d="M14.1666 19.1666H10.8333C9.68051 19.1666 8.69788 18.7603 7.88538 17.9478C7.07288 17.1353 6.66663 16.1527 6.66663 14.9999C6.66663 13.8471 7.07288 12.8645 7.88538 12.052C8.69788 11.2395 9.68051 10.8333 10.8333 10.8333H14.1666V12.4999H10.8333C10.1388 12.4999 9.54857 12.743 9.06246 13.2291C8.57635 13.7152 8.33329 14.3055 8.33329 14.9999C8.33329 15.6944 8.57635 16.2846 9.06246 16.7708C9.54857 17.2569 10.1388 17.4999 10.8333 17.4999H14.1666V19.1666ZM11.6666 15.8333V14.1666H18.3333V15.8333H11.6666ZM15.8333 19.1666V17.4999H19.1666C19.8611 17.4999 20.4513 17.2569 20.9375 16.7708C21.4236 16.2846 21.6666 15.6944 21.6666 14.9999C21.6666 14.3055 21.4236 13.7152 20.9375 13.2291C20.4513 12.743 19.8611 12.4999 19.1666 12.4999H15.8333V10.8333H19.1666C20.3194 10.8333 21.302 11.2395 22.1145 12.052C22.927 12.8645 23.3333 13.8471 23.3333 14.9999C23.3333 16.1527 22.927 17.1353 22.1145 17.9478C21.302 18.7603 20.3194 19.1666 19.1666 19.1666H15.8333Z"
                    fill="#766AFF"
                  />
                </g>
              </svg>
            </div>
            <div className="text">
              <h5 className="mb-2 text-primary-500 text-xs font-medium">
                Links shorter
              </h5>
              <div className="w-full text-xs text-accent-400 dark:text-accent-300">
                Shorten any URL to a compact and easy-to-remember format.
              </div>
            </div>
          </div>
        </div>
        <div className="drop-down-item | w-full box-border rounded-md cursor-pointer duration-300 hover:bg-primary-50 dark:hover:bg-accent-800">
          <div className="drop-down-item-container | flex gap-16px p-12px m-0 w-full">
            <div className="img">
              <svg
                width="30"
                height="30"
                viewBox="0 0 30 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  width="30"
                  height="30"
                  rx="15"
                  className="dark:fill-accent-700"
                />
                <mask
                  id="mask0_48_2204"
                  maskUnits="userSpaceOnUse"
                  x="6"
                  y="5"
                  width="19"
                  height="19"
                >
                  <rect x="6" y="5" width="19" height="19" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_48_2204)">
                  <path
                    d="M7.90002 14.1834V7.8501H14.2334V14.1834H7.90002ZM9.48336 12.6001H12.65V9.43343H9.48336V12.6001ZM7.90002 22.1001V15.7668H14.2334V22.1001H7.90002ZM9.48336 20.5168H12.65V17.3501H9.48336V20.5168ZM15.8167 14.1834V7.8501H22.15V14.1834H15.8167ZM17.4 12.6001H20.5667V9.43343H17.4V12.6001ZM20.5667 22.1001V20.5168H22.15V22.1001H20.5667ZM15.8167 17.3501V15.7668H17.4V17.3501H15.8167ZM17.4 18.9334V17.3501H18.9834V18.9334H17.4ZM15.8167 20.5168V18.9334H17.4V20.5168H15.8167ZM17.4 22.1001V20.5168H18.9834V22.1001H17.4ZM18.9834 20.5168V18.9334H20.5667V20.5168H18.9834ZM18.9834 17.3501V15.7668H20.5667V17.3501H18.9834ZM20.5667 18.9334V17.3501H22.15V18.9334H20.5667Z"
                    fill="#766AFF"
                  />
                </g>
              </svg>
            </div>
            <div className="text">
              <h5 className="mb-2 text-primary-500 text-xs font-medium">
                QR code generator{" "}
                <span className="bg-green-50 dark:bg-[#1d391d] text-green-500 py-1px px-2 rounded-sm ms-1">
                  New
                </span>
              </h5>
              <div className="w-full text-xs text-accent-400 dark:text-accent-300">
                Generate and export you links qr codes png, svg, jpeg...
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductsDropDown;
